import { Directive, inject, input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CORE_USER_ACTIVITY_SECTION } from '../services';

@Directive({
  selector: '[coreActivitySection]',
  standalone: true,
  providers: [
    {
      provide: CORE_USER_ACTIVITY_SECTION,
      useFactory: () => new BehaviorSubject<string>('unknown'),
    },
  ],
})
export class ActivitySectionDirective implements OnInit {

  private sectionSubject = inject(CORE_USER_ACTIVITY_SECTION);

  public readonly section = input.required<string>({
    alias: 'coreActivitySection',
  });

  public ngOnInit(): void {
    this.sectionSubject.next(this.section());
  }

}
